import { gql } from '@apollo/client'

export const pageViewSiteFragment = gql`
    fragment PageViewSiteFragment on Site {
        guid
        customTagsAllowed
        tagCategories {
            name
            values
        }
        activityFilter {
            contentTypes {
                key
                value
            }
        }
        searchFilter {
            contentTypes {
                key
                value
            }
        }
        searchDisplayedFilters
        searchTagFilters {
            name
            tagFilterEnabled
            tagFilterType
        }
        searchRelatedSitesEnabled
    }
`
